/**
 * @generated SignedSource<<f78bd7a73ad6249e77654a6861856f20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateProjectGroupInput = {
  id: string;
  name?: string | null;
  color?: string | null;
  statusColumns?: ReadonlyArray<StatusColumnInput | null> | null;
  sprintTimeBox?: boolean | null;
  sprintLengthInDays?: number | null;
  estimationUnit?: string | null;
  minutesPerEstimationPoint?: number | null;
  useManualAllocations?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StatusColumnInput = {
  id?: string | null;
  name?: string | null;
  order?: number | null;
  category?: string | null;
  projectId?: string | null;
  projectGroupStatusColumnId?: number | null;
  autoShowOnTimePage?: boolean | null;
  encourageTimeRegistration?: boolean | null;
};
export type updateProjectGroupMutation$variables = {
  input: UpdateProjectGroupInput;
};
export type updateProjectGroupMutation$data = {
  readonly updateProjectGroup: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly projectGroup: {
      readonly id: string;
      readonly name: string | null;
      readonly color: string | null;
      readonly projects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly estimationUnit: string | null;
            readonly sprintTimeBox: boolean | null;
            readonly sprintLengthInDays: number | null;
            readonly minutesPerEstimationPoint: number | null;
            readonly useManualAllocations: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type updateProjectGroupMutation = {
  variables: updateProjectGroupMutation$variables;
  response: updateProjectGroupMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProjectGroupPayload",
    "kind": "LinkedField",
    "name": "updateProjectGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectGroupType",
        "kind": "LinkedField",
        "name": "projectGroup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000
              }
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimationUnit",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sprintTimeBox",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sprintLengthInDays",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesPerEstimationPoint",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "useManualAllocations",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(first:100000)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectGroupMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectGroupMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8070fba9b53a18a55c07dca6212801f2",
    "id": null,
    "metadata": {},
    "name": "updateProjectGroupMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectGroupMutation(\n  $input: UpdateProjectGroupInput!\n) {\n  updateProjectGroup(input: $input) {\n    errors\n    projectGroup {\n      id\n      name\n      color\n      projects(first: 100000) {\n        edges {\n          node {\n            id\n            estimationUnit\n            sprintTimeBox\n            sprintLengthInDays\n            minutesPerEstimationPoint\n            useManualAllocations\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02c716b1a27975f942760cac6b1e7951";

export default node;
